import { ExportToCsv } from 'export-to-csv'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

import { transactionsCsvData } from '../../../../lib/account-history/export'
import HeaderWithSecondaryButton from '../HeaderWithSecondaryButton'
import TransactionsTable from './TransactionsTable'

const headerText = 'Transaction History'

const options = {
  filename: 'Transaction History',
  showLabels: true,
  headers: ['Date', 'Transaction', 'Charge', 'Payment'],
}

const csvExporter = new ExportToCsv(options)

// TODO: Check copy for no transaction history
const TransactionsContainer = ({ className, transactions }) => {
  if (transactions?.length) {
    const handleCsvExport = () => {
      csvExporter.generateCsv(transactionsCsvData(transactions))
    }

    return (
      <>
        <HeaderWithSecondaryButton
          buttonText="Export..."
          headerText="Transaction History"
          onClick={handleCsvExport}
        />
        <TransactionsTable transactions={transactions} />
      </>
    )
  }

  return (
    <div className={className}>
      <h3>{headerText}</h3>
      <div>No transaction history at the moment.</div>
    </div>
  )
}

TransactionsContainer.defaultProps = {
  className: '',
}

TransactionsContainer.propTypes = {
  className: PropTypes.string,
  urlFragment: PropTypes.string,
  transactions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      transactionNumber: PropTypes.string,
      date: PropTypes.string,
      payment: PropTypes.number,
      charge: PropTypes.number,
      type: PropTypes.string,
    }),
  ).isRequired,
}

const StyledTransactionsContainer = styled(TransactionsContainer)({
  h3: {
    marginBottom: '20px',
  },
})

export default StyledTransactionsContainer
